exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bn-tarifa-pages-section-container[data-v-44aaf678]{padding:8px;margin:15px}.bn-tarifa-pages-section-title[data-v-44aaf678]{font-size:20px;padding:10px}.bn-tarifa-pages-section-title>.v-icon[data-v-44aaf678]{color:#fff}.must-select-text[data-v-44aaf678],.selected-item-text[data-v-44aaf678]{position:relative;top:50%;left:50%;transform:translateX(-50%) translateY(-50%)}.bn-tarifa-pages-section-header-title[data-v-44aaf678]{width:100%;font-weight:lighter;border-bottom:2px solid}", ""]);

// exports
